import { computed } from "vue";
import { displayDateToIso, isoToDisplayDate } from "@/shared/utils/date-formatting";
/**
 * Bridges an ISO-stored date (wire format `yyyy-MM-dd`) to a display-format `v-model`
 * for OPAL's `DatePickerInput`.
 *
 * Rationale: `DatePickerInput` is a presentation component — it speaks the `format` prop
 * in both directions. Convention in this app is wire-format = ISO; conversion happens at
 * the binding boundary, never in stores or API payloads.
 *
 * Pass `userDateFormat` and `locale` as refs so the binding re-computes if the user
 * profile format or i18n locale change mid-edit (the ISO source stays intact; display updates).
 *
 * @example
 * const scheduleDateDisplay = useDateIsoBinding(
 *   toRef(store.schedule, 'date'),
 *   computed(() => profileStore.profile?.dateFormat),
 *   locale,
 * );
 * // <DatePickerInput v-model="scheduleDateDisplay" :format="dateFormat" />
 */
export function useDateIsoBinding(isoRef, userDateFormat, locale) {
    return computed({
        get: () => isoToDisplayDate(isoRef.value, userDateFormat.value, locale.value),
        set: (displayValue) => {
            isoRef.value = displayDateToIso(displayValue, userDateFormat.value, locale.value);
        },
    });
}
